import type { Account } from '../types/Account';

export function redirectToAccount(account: Account): void {
  window.location.href = account.appLink;
}
